import { render, staticRenderFns } from "./fieldTituloEleitorOrTaxDeclaration.vue?vue&type=template&id=0b5550c4"
import script from "./fieldTituloEleitorOrTaxDeclaration.vue?vue&type=script&lang=js"
export * from "./fieldTituloEleitorOrTaxDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports